import { useTranslate } from "ra-core";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { claveEtapa, esAparcada, embudoDe } from "../dominio/etapas";
import type { Etapa } from "../dominio/tipos";

const CLASE_ETAPA: Partial<Record<Etapa, string>> = {
  nuevo: "border-[#3D8BD4] text-[#336394] dark:text-[#6FA0D6]",
  aceptada: "border-green-600 text-green-700 dark:text-green-400",
  no_interesado:
    "border-red-300 text-red-700 dark:border-red-500 dark:text-red-400",
  no_contesta:
    "border-orange-300 text-orange-700 dark:border-orange-500 dark:text-orange-400",
  largo_plazo: "border-gray-300 text-muted-foreground dark:border-gray-600",
  baja: "border-gray-300 text-muted-foreground dark:border-gray-600",
};

/** Etiqueta de la etapa en castellano; las de Clientes, en verde. */
export const EtiquetaEtapa = ({
  etapa,
  className,
}: {
  etapa: Etapa;
  className?: string;
}) => {
  const translate = useTranslate();
  return (
    <Badge
      variant="outline"
      className={cn(
        "text-[11px] font-medium",
        embudoDe(etapa) === "clientes" &&
          "border-green-600 text-green-700 dark:text-green-400",
        CLASE_ETAPA[etapa],
        esAparcada(etapa) && "bg-muted",
        className,
      )}
    >
      {translate(claveEtapa(etapa))}
    </Badge>
  );
};
